import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import AlumniLogo from "../assets/svg/AlumniLogo.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
export interface NavItem {
    name: string;
    path: string;
    notification?: number;
}

export function Navbar({ navProps,showLocation }: { navProps: NavItem[] , showLocation:boolean}) {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    var navLocation = "";

    for (let i = 0; i < navProps.length; i++) {
        if (navProps[i].path === location.pathname) {
            navLocation = navProps[i].name;
        }
    }

    const openMenu = function () {
        if (isMenuOpen) {
            setIsMenuOpen(false);

        } else {
            setIsMenuOpen(true);
        }
    }

    const menuMobileCSS = function () {
        if (isMenuOpen) {
            return "menu-small-open";
        } else {
            return "menu-small-close";
        }
    }

    const menuBurgerCSS = function () {
        if (isMenuOpen) {
            return "menu-burger mb-o";
        } else {
            return "menu-burger mb-c";
        }
    }

    function notification(item: NavItem) {
        if (item.notification && item.notification > 0) {
            return (
                <div className="notification-circle"> {item.notification}</div>
            )
        }
    }

    return (
        <>
            <div className="nav">
                <div className="grow overflow-hidden">
                    <img src={AlumniLogo} alt="AlumniLogo" className="h-20 min-w-20" />
                </div>
                <div className="md:p-4 md:gap-4 md:collapse overflow-hidden max-sm:max-w-0 flex flex-row">
                    {navProps.map((item, index) => (
                        item.path === location.pathname ? (
                            <div className="relative navbutton-active flex h-10" key={index}><NavLink className="underline" to={item.path}>{item.name}</NavLink>{notification(item)} </div>

                        ) : (
                            <div className="relative navbutton flex h-10" key={index}><NavLink to={item.path}>{item.name}</NavLink>{notification(item)}</div>
                        )
                    ))}

                </div>
                <div className={menuMobileCSS()}>
                    {navProps.map((item, index) => (
                        item.path === location.pathname ? (
                            <div className="relative menuitem-button-active flex h-10" key={index}>  <NavLink className="underline" to={item.path}>{item.name}</NavLink>{notification(item)} </div>
                        ) : (
                            <div className="relative menuitem-button flex h-10" key={index}><NavLink to={item.path}>{item.name}</NavLink>{notification(item)}</div>

                        )
                    ))}
                </div>
                <div className={menuBurgerCSS()} onClick={openMenu}> <FontAwesomeIcon icon={faBars} /></div>


            </div>
            {(navLocation !== "" && showLocation)? <div className="nav-location"><div>{navLocation}</div></div> : <></>}
        </>
    );
}